import React from "react";

export type Feature = {
  name: string;
  description: string;
  disclosure?: string;
  icon: any;
};

type Props = {
  title?: string;
  description?: string;
  features: Feature[];
};

export const FeatureGridWithOffsetIcons = ({
  title,
  description,
  features,
}: Props) => {
  return (
    <div className="bg-white py-16">
      <div className="mx-auto px-8 text-center max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
        {title && (
          <h2 className="mt-2 text-3xl font-bold text-blue-500">{title}</h2>
        )}
        {description && (
          <p className="mt-5  mx-auto text-lg text-gray-700">{description}</p>
        )}
        <div className="mt-20">
          <div className="grid grid-cols-1 gap-x-4 gap-y-16 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 ">
            {features.map((feature, index) => (
              <div
                key={index}
                className="rounded-md px-3 pb-8 border border-gray-100 shadow-md"
              >
                <div className="-mt-8">
                  <div>
                    <div className="inline-flex items-center justify-center p-4 bg-yellow-500 rounded-lg">
                      <feature.icon className="h-9 w-9 text-white" />
                    </div>
                  </div>
                  <h3 className="mt-8 text-xl font-semibold text-blue-500 tracking-tight">
                    {feature.name}
                  </h3>
                  <p className="mt-5 text-base text-gray-700 flex-1">
                    {feature.description}
                  </p>
                  <p className="mt-5 text-sm text-gray-700 flex-1">
                    <i>{feature.disclosure}</i>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
